import { AuxButton, AuxIcon } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum, AuxIconStateEnum } from "@blk/aladdin-web-components";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { htmlToMarkdown, markdownToHtml } from "./markdownParser";
import { preview } from "common/constants";
import { FREE_TEXT_QUILL_FORMATS, registerSafeQuillLink } from "common/quill-security";
import { InsWidget } from "components";
import { useCreateCommentMutation, useListCommentsQuery, useUpdateCommentMutation } from "components/workspaces/store/api";
import { useGetCommentRequest } from "hooks/use-comments";
import "./insFreeTextWidget.scss";
import { language } from "language/default";
import { setIsReadOnly } from "store/messages-dialog";
registerSafeQuillLink();
const modules = {
    clipboard: {
        matchVisual: false,
        // Strip pasted images so they cannot be smuggled into stored HTML.
        matchers: [["img", () => ({ ops: [] })]]
    },
    toolbar: [
        ["bold", "italic"],
        [{ list: "bullet" }]
    ]
};
export const InsFreeTextWidget = (props) => {
    const { sectionId, widgetId } = props, dispatch = useDispatch();
    const [createComment] = useCreateCommentMutation(), request = useGetCommentRequest(widgetId), requestComments = useListCommentsQuery(request);
    const [updateComment] = useUpdateCommentMutation();
    const [comment, setComment] = useState(""), isReadOnly = useSelector((state) => state.messagesDialog.isReadOnly);
    const storedComment = requestComments.currentData?.comments[0];
    const handleSave = () => {
        dispatch(setIsReadOnly(true));
        const createCommentRequestParameters = {
            entityId: request.entityId ?? "",
            entityType: request.entityType ?? "",
            referenceDate: request.referenceDate
                ? {
                    day: request.referenceDate.getDate(),
                    month: request.referenceDate.getMonth() + 1,
                    year: request.referenceDate.getFullYear()
                }
                : {
                    day: new Date().getDate(),
                    month: new Date().getMonth() + 1,
                    year: new Date().getFullYear()
                },
            relationId: request.relationId,
            value: htmlToMarkdown(comment),
            widgetId
        };
        const updateCommentRequestParameters = {
            id: storedComment ? storedComment.id ?? "" : "",
            value: htmlToMarkdown(comment)
        };
        storedComment ? updateComment(updateCommentRequestParameters) : createComment(createCommentRequestParameters);
    };
    const handleCancel = () => {
        storedComment?.value && setComment(markdownToHtml(storedComment.value));
        dispatch(setIsReadOnly(true));
    };
    const editIcons = isReadOnly
        ? [
            React.createElement(AuxIcon, { key: "free-text-widget-edit", type: "livechat", state: AuxIconStateEnum["secondary-button"], isDisabled: sectionId === preview.sectionId, title: language.en.widgets.freeText.iconTitle, onClick: () => dispatch(setIsReadOnly(sectionId === preview.sectionId)) })
        ]
        : [
            React.createElement(AuxButton, { key: "free-text-widget-save", label: language.en.common.save, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.TERTIARY, onClick: handleSave }),
            React.createElement(AuxButton, { key: "free-text-widget-cancel", label: language.en.common.cancel, size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.TERTIARY, onClick: handleCancel })
        ];
    const content = React.createElement("div", { className: "free-text-widget" }, isReadOnly
        ? React.createElement("div", null,
            React.createElement(ReactQuill, { theme: "bubble", value: comment, readOnly: true, modules: modules, formats: FREE_TEXT_QUILL_FORMATS, placeholder: language.en.widgets.freeText.initialText }))
        : React.createElement(ReactQuill, { theme: "snow", value: comment, placeholder: language.en.widgets.freeText.initialText, modules: modules, formats: FREE_TEXT_QUILL_FORMATS, onChange: (x) => setComment(x) }));
    useEffect(() => {
        setComment(markdownToHtml(storedComment?.value || ""));
    }, [storedComment?.value]);
    return React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, additionalNodes: editIcons, content: content });
};
